<script setup>

</script>

<template>
  <div ml="8%">
    <div w="%" mt-24 mb-24>
      <div class="about-warp__right--title">
      {{ $t('jgzz') }}
    </div>
    <div class="about-warp__right--content qualification-box">
      <p>
        {{ $t('fdxgsxgjyszjjscyzjljscyzsxgzjhrkdcpftzybhbgp713') }} <br>
        {{ $t('cyxgzjh') }}
      </p>
      <img src="https://tg.fdzq.com/img/forthright-sec/images/about/sfc@2x.png">
      <ul>
        <li>
          <span>{{ $t('d1lsgghdpz') }}</span>
          <span>{{ $t('zqjy') }} </span>
        </li>
        <li>
          <span>{{ $t('d2lsgghdpz') }}</span>
          <span>{{ $t('qhhyjy') }} </span>
        </li>
        <li>
          <span>{{ $t('d4lsgghdpz') }}</span>
          <span>{{ $t('jzqtgyj') }} <label style='position: relative;left: 1px;'></label> </span>
        </li>
        <li>
          <span>{{ $t('d5lsgghdpz') }}</span>
          <span>{{ $t('jqhhytgyj') }} <label style='position: relative;left: 1px;'></label></span>
        </li>
      </ul>
    </div>
    </div>

  </div>
</template>
<style lang="less" scoped>
@import "../../assets/less/main.less";
@import "../assets/css/about.less";
@media screen and (max-width: 420px) {
  body {
    .qualification-box {
      li {
        display: flex;
        align-items: center;

        span {
          &:nth-child(1){
            margin-right: 0;
            width: 80px;
          }
          &:nth-child(2){
            flex: 1;
          }
        }
      }

    }
  }
}

.qualification-box {
  .font-size-line(14, 20);
  color: #61676B;

  img {
    width: 309px;
    margin: 15px 0 25px 0;
  }

  li {
    margin-bottom: 20px;
    color: #000000;
  }

  span {
    &:nth-child(1) {
      color: #1D2228;
      font-weight: 600;
      margin-right: 43px;
    }
  }
}
</style>
